import { captureException } from "@sentry/react";
import { Modal } from "components";
import React from "react";
import { Button } from "semantic-ui-react";

interface Props {
  title: string
  textContent?: string
  yesButtonLabel: string
  yesButtonColor: "red" | "green";
  onYes: () => Promise<unknown>;
  onClose: () => void
}

const AreYouSureModal = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<boolean | string>(false);

  const onYes = async () => {
    setIsLoading(true);
    try {
      const res = await props.onYes();
      if (res != null && typeof res === "object" && "hasErrors" in res && res.hasErrors) {
        const resObj = res as server.dto.ApiResponse;
        setError(resObj.errors[0].message);
        setIsLoading(false);
        return;
      }
      props.onClose();
    } catch (e) {
      setError(true);
      setIsLoading(false);
      captureException(e);
      console.error(e);
    }
  };

  return <Modal
    isOpen
    handleClose={props.onClose}
    title={props.title}
  >
    {props.textContent ?? RESX.GeneralWarnings.AreYouSure}

    <div className="grow1">
    </div>
    {error && <div className="s1_red margin-bottom">{typeof error === "string" ? error : RESX.GeneralLabels.SomethingUnexpectedHappened}</div>}

    <div className="flex">
      <div className="grow1"></div>
      <Button disabled={isLoading} loading={isLoading} color={props.yesButtonColor} type="button" onClick={() => { onYes(); }}>
        {props.yesButtonLabel}
      </Button>
    </div>
  </Modal>;
};

export default AreYouSureModal;
